module.exports = require("chartjs-chart-geo");